import React from 'react';

import useMaintenanceStatuses from 'core/hooks/useMaintenanceStatuses';
import { MaintenanceStatus as Status } from 'core/types/maintenanceStatus';

type Props = {
  id: Status['id'];
};

export default function MaintenanceStatus({ id }: Props) {
  const statuses = useMaintenanceStatuses();

  if (statuses.length === 0) {
    return <>Ladataan...</>;
  }

  const status = statuses.find(status => status.id === id);

  return <>{status ? status.label : 'Tuntematon tila'}</>;
}
